import { useEffect } from "react";
import { Pagination } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useUserStore } from "../../store/user.store";

const Paginate = (props) => {
  const defaultPageNumber = useUserStore((state) => state.resetPageNumber);
  const searchValue = useUserStore((state) => state.search);

  // When search value changes or reset request is made, set page number to 1
  useEffect(() => {
    props.setPage(1);
  }, [defaultPageNumber, searchValue]);

  const handlePrevClick = () => {
    if (isFirstPage()) return;
    props.setPage(props.page - 1);
  };

  const handleNextClick = () => {
    if (isLastPage()) return;
    props.setPage(props.page + 1);
  };

  const handlePageClick = (page) => {
    props.setPage(page);
  };

  const isFirstPage = () => props.page === 1;
  const isLastPage = () => props.page === props.pageCount;

  const generatePaginationItems = () => {
    const { page, pageCount } = props;
    const items = [];

    // If the page is within the last three pages
    if (pageCount > 10) {
      if (page > pageCount - 3) {
        // Display the first three pages
        for (let number = 1; number <= 3; number++) {
          items.push(
            <Pagination.Item
              key={number}
              active={number === page}
              onClick={() => handlePageClick(number)}
            >
              {number}
            </Pagination.Item>
          );
        }
        items.push(<Pagination.Ellipsis key="ellipsis" disabled />);
      } else {
        // First three pages (dynamic shifting)
        const startRangeEnd = page >= 3 ? Math.min(page + 2, pageCount - 3) : 3;
        for (
          let number = Math.max(1, startRangeEnd - 2);
          number <= startRangeEnd;
          number++
        ) {
          items.push(
            <Pagination.Item
              key={number}
              active={number === page}
              onClick={() => handlePageClick(number)}
            >
              {number}
            </Pagination.Item>
          );
        }
      }

      // Ellipsis
      if (page < pageCount - 2) {
        items.push(<Pagination.Ellipsis key="ellipsis" disabled />);
      }

      // Last three pages
      for (
        let number = Math.max(pageCount - 2, 4);
        number <= pageCount;
        number++
      ) {
        items.push(
          <Pagination.Item
            key={number}
            active={number === page}
            onClick={() => handlePageClick(number)}
          >
            {number}
          </Pagination.Item>
        );
      }
    } else {
      for (let number = 1; number <= pageCount; number++) {
        items.push(
          <Pagination.Item
            key={number}
            active={number === page}
            onClick={() => handlePageClick(number)}
          >
            {number}
          </Pagination.Item>
        );
      }
    }

    return items;
  };

  return (
    <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-5 tw-py-4 tw-text-xs md:tw-flex-row md:tw-justify-between">
      <div className="tw-text-secondary-dark-text">Page {props.page}</div>

      <div className="tw-w-fit">
        <Pagination size="xs" className="pagination-gutter pagination-circle">
          <li
            className={`${
              isFirstPage()
                ? "disabled tw-cursor-not-allowed"
                : "tw-cursor-pointer"
            } page-item page-indicator`}
            onClick={handlePrevClick}
          >
            <Link className="page-link" to="#">
              <i className="la la-angle-left" />
            </Link>
          </li>

          {generatePaginationItems()}

          <li
            className={`${
              isLastPage()
                ? "disabled tw-cursor-not-allowed"
                : "tw-cursor-pointer"
            } page-item page-indicator`}
            onClick={handleNextClick}
          >
            <Link className="page-link" to="#">
              <i className="la la-angle-right" />
            </Link>
          </li>
        </Pagination>
      </div>

      {props.pageSizeZero ? (
        <div>Showing 0 entries</div>
      ) : (
        <div>
          Showing{" "}
          {`${(props.page - 1) * props.pageSize + 1} to
        ${
          (props.query?.result[props.datastring ?? "items"]?.length ?? 0) +
          (props.page - 1) * props.pageSize
        }
        
    ${
      Boolean("totalCount" in props.query?.result)
        ? " of " + props.query?.result.totalCount + " entries"
        : ""
    }`}
        </div>
      )}
    </div>
  );
};

export default Paginate;
